import { actionTypes } from './constants';
import { apiCallStatus } from 'helpers/constants';
import { getApiActionCreator } from 'helpers/actionHelper';
import { TimeSeriesApi, SubscriptionInfoApi, AnalyticsApi } from 'api';
import CapabilityHelper from 'helpers/newCapabilityHelper';
import { opButtons } from '../ChartView/constants';
import { getCrossAssetAnalysisActiveTab } from './selectors';

const getKPIsForKPITypeAction = getApiActionCreator(actionTypes.GET_KPIS_FOR_KPI_TYPE);

export const setShoulScrollToSelection = (shouldScrollToSelection) => {
    return {
        type: actionTypes.SET_SHOULD_SCROLL_TO_SELECTION,
        shouldScrollToSelection
    };
};

const setSelectedAssetAction = (asset) => {
    return {
        type: actionTypes.SET_SELECTED_ASSET,
        asset
    };
};

export const clearStore = () => {
    return (dispatch) => {
        dispatch({ type: actionTypes.CLEAR_STORE });
    };
};

const clearKIPListAction = (asset) => {
    return {
        type: actionTypes.CLEAR_KPI_LIST,
        asset
    };
};

export const setKpi = (selectedKpi, asset) => {
    console.log('The Selected KPI information', selectedKpi, asset);
    return {
        type: actionTypes.SET_SELECTED_KPI,
        selectedKpi,
        asset
    };
};

export const setActiveTabAction = (activeTab) => {
    return {
        type: actionTypes.SET_ACTIVE_TAB,
        activeTab
    };
};

export const setSearchboxFilterAction = (searchboxFilter) => {
    return {
        type: actionTypes.SET_SEARCHBOX_FILTER,
        searchboxFilter
    };
};

export const setGatewayTypeFilterAction = (gatewayTypeFilter) => {
    return {
        type: actionTypes.SET_GATEWAY_TYPE_FILTER,
        gatewayTypeFilter
    };
};

export const setSelectedPowertrainID = (powertrain) => {
    return {
        type: actionTypes.SET_SELECTED_POWERTRAIN,
        powertrain
    };
};

export const setSelectedAsset = (asset) => {
    return dispatch => {
        dispatch(clearKIPListAction());
        dispatch(setSelectedAssetAction(asset));
    };
};

export const getTrendKPIsForAssetV2 = (asset, capability, kpiType) => {
    return (dispatch, getState) => {
        dispatch(getKPIsForKPITypeAction(apiCallStatus.LOADING));
        const capabilityHelper = new CapabilityHelper(capability, asset);
        if (capabilityHelper.hasPlotTypeCapability(kpiType) &&
            capabilityHelper.hasCrossAssetAnalysisCapability()) {

            dispatch(getKPIsForKPITypeAction(apiCallStatus.LOADING));
            return TimeSeriesApi.getMeasurementTypes(asset?.id)
                .then((data) => {
                    const activeTab = getCrossAssetAnalysisActiveTab(getState());
                    if (activeTab === opButtons.trend) {
                        const timeSeries = data.map((value) => value.timeseries.flat());
                        dispatch(getKPIsForKPITypeAction(apiCallStatus.SUCCESS, timeSeries.flat()));
                        return data;
                    }
                })
                .catch((err) => {
                    dispatch(getKPIsForKPITypeAction(apiCallStatus.ERROR, null, err));
                });
        } else {
            dispatch(getKPIsForKPITypeAction(apiCallStatus.SUCCESS, []));
        }
    };
};

// Histogram V2 Config API
export const getHistogramKPIsForAsset = (asset, capability, kpiType) => {
    return (dispatch, getState) => {
        dispatch(getKPIsForKPITypeAction(apiCallStatus.LOADING));
        const capabilityHelper = new CapabilityHelper(capability, asset);
        if (capabilityHelper.hasPlotTypeCapability(kpiType) &&
            capabilityHelper.hasCrossAssetAnalysisCapability()) {

            AnalyticsApi.getHistogramV2Config(asset?.id)
                .then((data) => {
                    const activeTab = getCrossAssetAnalysisActiveTab(getState());
                    if (activeTab === opButtons.histogramV2) {
                        dispatch(getKPIsForKPITypeAction(apiCallStatus.SUCCESS, data?.histograms));
                    }
                })
                .catch((err) => {
                    dispatch(getKPIsForKPITypeAction(apiCallStatus.ERROR, null, err));
                });
        } else {
            dispatch(getKPIsForKPITypeAction(apiCallStatus.SUCCESS, []));
        }
    };
};

// Scatter plot V2 Config API
export const getScatterPlotKPIsForAsset = (asset, capability, kpiType) => {
    return (dispatch, getState) => {
        dispatch(getKPIsForKPITypeAction(apiCallStatus.LOADING));
        const capabilityHelper = new CapabilityHelper(capability, asset);
        if (capabilityHelper.hasPlotTypeCapability(kpiType) &&
            capabilityHelper.hasCrossAssetAnalysisCapability()) {

            AnalyticsApi.getScatterV2Config(asset?.id)
                .then((data) => {
                    const activeTab = getCrossAssetAnalysisActiveTab(getState());
                    if (activeTab === opButtons.scatterPlotV2) {
                        dispatch(getKPIsForKPITypeAction(apiCallStatus.SUCCESS, data));
                    }
                })
                .catch((err) => {
                    dispatch(getKPIsForKPITypeAction(apiCallStatus.ERROR, null, err));
                });
        } else {
            dispatch(getKPIsForKPITypeAction(apiCallStatus.SUCCESS, []));
        }
    };
};

export const getKPIsForKPIType = (asset, capability, kpiType) => {
    return (dispatch, getState) => {
        const capabilityHelper = new CapabilityHelper(capability, asset);
        if (capabilityHelper.hasPlotTypeCapability(kpiType) &&
            capabilityHelper.hasCrossAssetAnalysisCapability()) {
            const activeTab = getCrossAssetAnalysisActiveTab(getState());
            if (activeTab === opButtons.histogramV2) {
                return dispatch(getHistogramKPIsForAsset(asset, capability, kpiType));
            } else if (activeTab === opButtons.scatterPlotV2) {
                return dispatch(getScatterPlotKPIsForAsset(asset, capability, kpiType));
            } else if (activeTab === opButtons.trend) {
                return dispatch(getTrendKPIsForAssetV2(asset, capability, kpiType));
            } else {
                dispatch(getKPIsForKPITypeAction(apiCallStatus.SUCCESS, []));
            }
        } else {
            dispatch(getKPIsForKPITypeAction(apiCallStatus.SUCCESS, []));
        }
    };
};

const getContractsAction = getApiActionCreator(actionTypes.ACTIVE_SUB_DATA);

export const getSubscriptionInfo = (assetIdParams) => {
    return (dispatch) => {
        dispatch(getContractsAction(apiCallStatus.LOADING));
        SubscriptionInfoApi.getSubscriptionList(assetIdParams)
            .then((data) => {
                dispatch(getContractsAction(apiCallStatus.SUCCESS, data));
            }, (err) => {
                dispatch(getContractsAction(apiCallStatus.ERROR, null, err));
            });
    };
};
